import { SelectProps } from "@cofano/cck/Select/Select";
import { PayableOver } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

const PayableOverSelect = ({ value, onChange, options }: Omit<SelectProps<PayableOver, false>, "fetchOptions"> & { options?: PayableOver[] }) => {
	const fetchOptions = options ? Object.values(options) : Object.values(PayableOver);

	return (
		<Select
			fetchOptions={fetchOptions}
			getOptionLabel={(option) => intl.formatMessage({ id: `PAYABLE_OVER_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default PayableOverSelect;
